import { useState } from 'react';
import { Loader2, Sparkles } from 'lucide-react';
import { CARD, INPUT, PRIMARY } from './ui';

export interface Revision { number: number; feedback: string; at: string }

interface Props {
  isOnline: boolean;
  revisions: Revision[];
  onRevise(instructions: string): Promise<boolean>;
}

/** Whole-report revision in plain English, with this session's history. */
export function ReviseCard({ isOnline, revisions, onRevise }: Props) {
  const [text, setText] = useState('');
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      if (await onRevise(text.trim())) setText('');
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className={CARD}>
      <h3 className="mb-2 text-sm font-bold text-slate-900">Revise Report</h3>
      <p className="mb-3 text-xs text-slate-500">Tell the AI what to change in plain English.</p>
      {revisions.length > 0 && (
        <div className="mb-3 rounded-xl bg-slate-50 p-3">
          <h4 className="mb-2 text-xs font-bold text-slate-700">Revision History ({revisions.length})</h4>
          {revisions.map((r) => (
            <div key={r.number} className="mb-1.5 text-xs">
              <span className="font-semibold text-slate-600">Rev {r.number}</span>
              <span className="ml-1 text-slate-400">{new Date(r.at).toLocaleTimeString()}</span>
              <p className="mt-0.5 italic text-slate-500">&quot;{r.feedback}&quot;</p>
            </div>
          ))}
        </div>
      )}
      <textarea
        value={text}
        onChange={(e) => setText(e.target.value)}
        placeholder="e.g. 'add that the transfer switch was corroded' or 'remove the fuel tank section'"
        rows={3}
        maxLength={2000}
        className={`${INPUT} mb-3`}
      />
      <button type="button" onClick={() => void run()} disabled={!isOnline || busy || !text.trim()} className={`${PRIMARY} min-h-[48px] w-full`}>
        {busy ? <><Loader2 size={16} className="animate-spin" /> Revising...</> : <><Sparkles size={16} /> Revise Report</>}
      </button>
    </div>
  );
}
